<div class="designs-thumbnail-component">
    <!-- Header -->
    <div
        *ngIf="showHeader"
        class="h-{{heightHeader}} designs-thumbnail-item">
        <!-- Content -->
        <div
            *ngIf="model.headerSetting.showContent && (model.headerSetting.contents | filterContentUrl : language)"
            [style.backgroundColor]="model.headerSetting.headerContentSetting.backgroundColor"
            [style.paddingTop]="model.headerSetting.headerContentSetting.padding?.top + 'px'"
            [style.paddingBottom]="model.headerSetting.headerContentSetting.padding?.bottom + 'px'"
            [style.paddingLeft]="model.headerSetting.headerContentSetting.padding?.left + 'px'"
            [style.paddingRight]="model.headerSetting.headerContentSetting.padding?.right + 'px'"
            [style.textAlign]="model.headerSetting.headerContentSetting.alignmentType | alignment">
            <img
                [src]="model.headerSetting.contents | filterContentUrl : language"
                class="img-fluid"
                [style.width]="model.headerSetting.headerContentSetting.isFullWidth ? '100%' : 'auto'"
                [style.height]="model.headerSetting.headerContentSetting.isFullWidth ? 'auto' : model.headerSetting.headerContentSetting.height + 'px'" />
        </div>
        <!-- Text -->
        <div
            *ngIf="model.headerSetting.showText"
            [style.backgroundColor]="model.headerSetting.headerTextSetting.backgroundColor"
            [style.paddingTop]="model.headerSetting.headerTextSetting.padding?.top + 'px'"
            [style.paddingBottom]="model.headerSetting.headerTextSetting.padding?.bottom + 'px'"
            [style.paddingLeft]="model.headerSetting.headerTextSetting.padding?.left + 'px'"
            [style.paddingRight]="model.headerSetting.headerTextSetting.padding?.right + 'px'">
            <div [innerHtml]="(model.headerSetting.translations | filterLanguage: language) | keepHtml"></div>
        </div>
    </div>

    <!-- Banner -->
    <div
        *ngIf="showBanner"
        class="h-{{heightBanner}} designs-thumbnail-item"
        [style.backgroundColor]="model.bannerSetting.backgroundColor">
        <img
            [src]="model.bannerSetting.contents | filterContentUrl : language : contentContextType : mediaTypeEmail"
            class="img-fluid"
            width="100%"
            height="auto" />
    </div>

    <!-- Content -->
    <div
        class="h-{{heightContent}} designs-thumbnail-item"
        [style.backgroundColor]="model.contentSetting.contentBlockSetting.backgroundColor">
        <!-- Titles and text -->
        <div class="px-4 pt-4">
            <h3
                [style.color]="model.contentSetting.contentTitleSetting.textColor"
                [style.fontFamily]="model.contentSetting.contentTitleSetting.fontFamily">
                {{ 'ROUTES.TEMPLATES.DESIGNS.TITLE.LABEL' | translate }}
            </h3>
            <h5
                [style.color]="model.contentSetting.contentBlockSetting.textColor"
                [style.fontFamily]="model.contentSetting.contentBlockSetting.fontFamily"
                style="text-indent: 5%;">
                {{ 'ROUTES.TEMPLATES.DESIGNS.SMALLTITLE.LABEL' | translate }}
            </h5>
            <p
                [style.color]="model.contentSetting.contentBlockSetting.textColor"
                [style.fontFamily]="model.contentSetting.contentBlockSetting.fontFamily"
                style="text-indent: 10%;">
                {{ 'ROUTES.TEMPLATES.DESIGNS.TEXT.LABEL' | translate }}
            </p>
        </div>
        <!-- Buttons -->
        <div class="p-2">
            <div class="centered-content">
                <button
                    class="btn full-button"
                    [ngStyle]="styleService.getFullButtonStyle(model)"
                    [style.width]="'100%'"
                    [style.borderRadius]="model.buttonSetting.borderRadius + 'px'">
                    {{ 'INPUT.BUTTON.FULL.LABEL' | translate }}
                </button>
            </div>
            <div class="centered-content mt-2">
                <button
                    class="btn hollow-button"
                    [ngStyle]="styleService.getHollowButtonStyle(model)"
                    [style.width]="'100%'"
                    [style.borderRadius]="model.buttonSetting.borderRadius + 'px'">
                    {{ 'INPUT.BUTTON.HOLLOW.LABEL' | translate }}
                </button>
            </div>
        </div>
    </div>

    <!-- Footers -->
    <div
        *ngIf="showFooter"
        class="h-{{heightFooter}} designs-thumbnail-item">
        <div *ngFor="let footer of model.footers">
            <app-footer-view [model]="footer.footer" [language]="language"></app-footer-view>
        </div>
    </div>
</div>